import { render, staticRenderFns } from "./contragents-list.vue?vue&type=template&id=62c95db6"
import script from "./contragents-list.vue?vue&type=script&lang=js"
export * from "./contragents-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports